module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "articledetailpage",
    class: {
      'bodyfont-unauth': !_vm.user
    }
  }, [(_vm.toggleSpinner) ? _c('spinner', {
    staticClass: "pink",
    attrs: {
      "size": "lg",
      "fixed": "",
      "text": "fetching article"
    },
    model: {
      value: (_vm.toggleSpinner),
      callback: function($$v) {
        _vm.toggleSpinner = $$v
      },
      expression: "toggleSpinner"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleObject) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('h3', {
    staticClass: "titleofarticle"
  }, [_vm._v(_vm._s(_vm.articleObject.articleHead))]), _vm._v(" "), (!_vm.articleObject.authorUrl) ? _c('h6', [_vm._v(_vm._s(_vm.articleObject.authorName) + " - " + _vm._s(_vm.articleObject.datePublishFmt))]) : _vm._e(), _vm._v(" "), (_vm.articleObject.authorUrl) ? _c('h6', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.articleObject.authorUrl
    }
  }, [_vm._v(_vm._s(_vm.articleObject.authorName))]), _vm._v(" - " + _vm._s(_vm.articleObject.datePublishFmt))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "imageholderbanner"
  }, [_c('img', {
    attrs: {
      "src": _vm.articleObject.imageUrl,
      "title": _vm.articleObject.articleHead,
      "alt": _vm.articleObject.articleHead
    }
  })]), _vm._v(" "), _c('social-sharing', {
    attrs: {
      "url": _vm.videoURL,
      "quote": _vm.articleObject.articleHead,
      "description": _vm.articleObject.articleHead,
      "title": 'TONE Networks, Set the Tone of Your Life'
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', {
            staticClass: "shareIcons"
          }, [_c('network', {
            staticClass: "holder",
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-facebook cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-twitter cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-envelope cursor"
          })])], 1)
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.articleList && _vm.articleList.length > 0) ? _c('div', {
    staticClass: "col-sm-8"
  }, [(_vm.articleObject.paragraph1) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph1)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleObject.paragraph2) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph2)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleObject.paragraph3) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph3)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleObject.paragraph4) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph4)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleObject.paragraph5) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph5)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleObject.paragraph6) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph6)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleObject.paragraph7) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph7)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleObject.paragraph8) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph8)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleObject.paragraph9) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph9)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleObject.paragraph10) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph10)
    }
  }) : _vm._e(), _vm._v(" "), _c('social-sharing', {
    attrs: {
      "url": _vm.videoURL,
      "quote": _vm.articleObject.articleHead,
      "description": _vm.articleObject.articleHead,
      "title": 'TONE Networks, Set the Tone of Your Life'
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', {
            staticClass: "shareIcons bottom"
          }, [_c('network', {
            staticClass: "holder",
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-facebook cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-twitter cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-envelope cursor"
          })])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1) : _c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.articleObject.paragraph1) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph1)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleObject.paragraph2) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph2)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleObject.paragraph3) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph3)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleObject.paragraph4) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph4)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleObject.paragraph5) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph5)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleObject.paragraph6) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph6)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleObject.paragraph7) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph7)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleObject.paragraph8) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph8)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleObject.paragraph9) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph9)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articleObject.paragraph10) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleObject.paragraph10)
    }
  }) : _vm._e(), _vm._v(" "), _c('social-sharing', {
    attrs: {
      "url": _vm.videoURL,
      "quote": _vm.articleObject.articleHead,
      "description": _vm.articleObject.articleHead,
      "title": 'TONE Networks, Set the Tone of Your Life'
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', {
            staticClass: "shareIcons bottom"
          }, [_c('network', {
            staticClass: "holder",
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-facebook cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-twitter cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-envelope cursor"
          })])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), (_vm.articleList && _vm.articleList.length > 0) ? _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "pinklinksholder"
  }, [_c('h4', [_vm._v("More Articles")]), _vm._v(" "), _vm._l((_vm.articleList), function(article) {
    return _c('div', [_c('div', {
      staticClass: "listholderlinks"
    }, [_c('a', {
      attrs: {
        "href": "javascript:",
        "title": article.articleHead
      },
      on: {
        "click": function($event) {
          return _vm.redirectToNextArticle(article)
        }
      }
    }, [_vm._v(_vm._s(article.articleHead))]), _c('small', {
      on: {
        "click": function($event) {
          return _vm.redirectToNextArticle(article)
        }
      }
    }, [_vm._v(_vm._s(article.authorName) + " - " + _vm._s(article.datePublishFmt))])])])
  })], 2)]) : _vm._e()])], 1) : _vm._e()], 1)
},staticRenderFns: []}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-196d8168"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_live_NgwNoBs3GAlrsSez07Zyh4Jc"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www.tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/assets.tonenetworks.com/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/SetTone.vue